import { useState } from 'react';
import { Button, Modal } from 'rsuite';
import { useTranslation } from 'react-i18next';
import { InfoButton } from '@commonClient2/components';
import NotificationTags from './NotificationTags';
import './CustomTagsDisplay.scss';

function CustomTagsDisplay() {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'admin.setupEdit.notificationStep' });
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <div className="ctd-container">
            <InfoButton
                onClick={() => setIsModalOpen(true)}
                text={t('customTagsButtonLabel')}
            />
            <Modal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                className="ctd-modal"
                style={{ zIndex: 1300 }}
                size="md"
            >
                <Modal.Title>{t('customTagsButtonLabel')}</Modal.Title>
                <Modal.Body
                    className="modal-body"
                >
                    <NotificationTags />
                </Modal.Body>
                <Modal.Footer>
                    <div className="modal-footer">
                        <Button
                            onClick={() => setIsModalOpen(false)}
                            appearance="primary"

                        >
                            {t('customTagsModalButtonLabel')}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default CustomTagsDisplay;
